<!-- Copyright: Seán I. O'Donoghue -->

<template>
  <!-- the four video statuses (fullstack/claude/VIDEOS.md), worded by Seán (2026-10-21) -->
  <ul v-if="!$route.params.vimeoHash" id="legend">
    <!-- partial access (one collection of two): both icons, each naming its collection -->
    <li v-if="accessState !== 'none'">
      <img src="@/assets/img/unlocked.png" class="lock" alt="Unlocked" />
      = You have access<template v-if="accessState === 'partial'">
        ({{ unlockedName }})</template>
    </li>
    <li v-if="accessState !== 'full'">
      <img src="@/assets/img/lock-orange.png" class="lock" alt="Locked" />
      = Requires purchase<template v-if="accessState === 'partial'">
        ({{ lockedName }})</template>
    </li>
    <!-- signed out, a Free video's thumbnail has an orange badge (GalleryItem.vue) -->
    <li v-if="!isSignedIn"><span class="freeTag">Free</span> = Requires sign-up</li>
    <li>No icon = Public</li>
  </ul>
</template>

<script setup>
import {computed} from "vue";
import useUserSafe from "@/composables/useUserSafe";
import useVideoAccess from "@/composables/useVideoAccess";
const {isSignedIn} = useUserSafe();
const {hasWorkshopAccess, accessState} = useVideoAccess();
const unlockedName = computed(() => (hasWorkshopAccess.value ? "Workshop" : "Masterclass"));
const lockedName = computed(() => (hasWorkshopAccess.value ? "Masterclass" : "Workshop"));
</script>

<style scoped>
/* scoped = CSS limit to this component only */
ul#legend {
  margin-left: 0px;
  padding-left: 0px;
  margin-top: 8px;
  margin-bottom: 0px;
  padding-bottom: 0px;
  font-weight: 300;
  font-size: 0.95rem;
}
li {
  display: inline;
}
li + li {
  margin-left: 6px;
}
li + li::before {
  margin-right: 6px;
  content: " | "; /* https://stackoverflow.com/q/9171699 */
}
img.lock {
  width: 0.8rem;
}
/* as the thumbnail's badge (GalleryItem.vue), small */
.freeTag {
  padding: 0.05rem 0.45rem;
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--orange-on-dark);
  background: rgba(0, 0, 0, 0.72);
  border-radius: 999px;
}
</style>
